<template>
<footer class="footer">
  <div class="footer-container">
    <div class="footer-note">
      <p>&copy; 2026 <a href="/" class="footer-link">appsgb.org</a> This site only shares guides and news about GBWhatsApp. All rights belong to their owners.</p>
    </div>
    <div class="footer-links">
      <a href="/privacy-policy/" class="footer-link">Privacy Policy</a>
      <span class="footer-links-sep" aria-hidden="true">|</span>
      <a href="/contact/" class="footer-link">Contact</a>
      <span class="footer-links-sep" aria-hidden="true">|</span>
      <a href="/about/" class="footer-link">About</a>
      <span class="footer-links-sep" aria-hidden="true">|</span>
      <a href="/disclaimer/" class="footer-link">Disclaimer</a>
    </div>

  </div>
</footer>
</template>

<script>
export default {
  name: 'Footer'
}
</script>

<style lang="scss" scoped>
.footer {
  // background-color: #282828;
  background-color: #fff;
  color: #121212;
  padding: 15px 0;
}
@media (max-width: 768px) {
  .footer {
    padding: 10px 0 50px;
  }
}

.footer-container {
  width: 80%;
  max-width: 100%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 6px;
}

.footer-links {
  width: 100%;
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  /* 极窄屏时第二行可横向滑动，仍保持「整段链接算一行」 */
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  /* 比版权说明行（15px）小一号 */
  font-size: 14px;
}

.footer-links-sep {
  color: #121212;
  opacity: 0.35;
  padding: 0 8px;
  user-select: none;
  font-size: inherit;
}

.footer-link {
  color: #1b3d76;
  text-decoration: none;
  transition: color 0.3s;
}

.footer-note .footer-link {
  font-size: inherit;
}

.footer-links .footer-link {
  font-size: inherit;
}

.footer-link:hover {
  color: #2880ba;
}

.footer-note {
  width: 100%;
  font-size: 0.95rem;
  line-height: 1.65;
  color: var(--read-text-muted, #6b7280);

  p {
    margin: 0;
  }

  .footer-link {
    font-size: inherit;
  }
}

/* Responsive Design */
@media (max-width: 768px) {
  .footer-links {
    font-size: 0.8rem;
  }

  .footer-note {
    font-size: 0.8rem;
    line-height: 1.55;
  }
}
</style>
